import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";

class DynamicRadioControl extends React.Component {
  render() {
    let field = this.props.field;

    if (this.props.isBoolean === true) {
      return (
        <FormControl component="fieldset" margin="none" fullWidth>
          <fieldset className="entity-fieldset">
            <Typography component="legend" color="primary">
              <legend>
                {field.IsMandatory ? "*" : ""}
                {field.FieldName}
              </legend>
            </Typography>
            <p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
            <RadioGroup
              defaultValue={this.props.defaultValue}
              name={field.FieldCode}
              onChange={this.props.eventHandle}
              style={{ marginLeft: 10 }}
            >
              <FormControlLabel
                value={"true"}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                value={"false"}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
            <Typography variant="body2" color="error">
              {this.props.fieldError}
            </Typography>
          </fieldset>
        </FormControl>
      );
    } else {
      return (
        <FormControl component="fieldset" margin="none" fullWidth>
          <fieldset className="entity-fieldset">
            <Typography component="legend" color="primary">
              <legend>
                {field.IsMandatory ? "*" : ""}
                {field.FieldName}
              </legend>
            </Typography>
            <p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
            <RadioGroup
              defaultValue={this.props.defaultValue}
              name={field.FieldCode}
              onChange={this.props.eventHandle}
              style={{ marginLeft: 10 }}
            >
              {field.Options.map((option) => (
                <FormControlLabel
                  value={option.Key}
                  key={option.Key}
                  control={<Radio />}
                  label={option.Value}
                />
              ))}
            </RadioGroup>

            <Typography variant="body2" color="error">
              {this.props.fieldError}
            </Typography>
          </fieldset>
        </FormControl>
      );
    }
  }
}

export default DynamicRadioControl;
